import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ListHeader } from '@app/components/ListHeader';
import { HeaderAction, HeaderActionTypes, ListHeaderActions } from '@app/components/ListHeaderActions';
import { DefaultTable } from '@app/components/common/Table/DefaultTable';
import { ColumnInterface, GenericObjectWithActions } from '@app/components/common/Table/DefaultTable/types';

import './styles.css';

interface CustomActionListProps {
  resource: string;
  title: string;
  rowsWithActions: GenericObjectWithActions[] | undefined;
  columns: ColumnInterface[];
  additionalHeaderActions?: HeaderAction[];
  replacementHeaderActions?: HeaderAction;
  handleChangeLoading(loading: boolean): void;
  isLoading: boolean;
}

/**
 * Each row is responsible for its own set of actions.
 * This is useful if we want different actions for each row,
 * e.g. an "Activated" or "Deactivated" row
 */
export const CustomActionList = ({
  resource,
  handleChangeLoading,
  title,
  columns,
  additionalHeaderActions,
  isLoading,
  rowsWithActions: rows,
}: CustomActionListProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    handleChangeLoading(!!isLoading);
  }, [isLoading, handleChangeLoading]);

  const onCreateNew = () => {
    navigate(`/${resource}/create`);
  };

  const defaultHeaderActions = [{ id: 1, type: HeaderActionTypes.ADD_NEW, handler: onCreateNew }];

  return (
    <div className="custom-action-list_container">
      <ListHeader title={title} />
      <ListHeaderActions
        headerActions={
          additionalHeaderActions ? [...defaultHeaderActions, ...additionalHeaderActions] : defaultHeaderActions
        }
      />
      <DefaultTable title={title} rows={rows} columns={columns} resource={resource} />
    </div>
  );
};
